


import { useMemo, useState } from "react";

import { Box, Stack } from "@mui/system";
import { LoadingButton } from "@mui/lab";
import { Alert, Typography } from "@mui/material";

import { useRouter } from "src/routes/hooks";
import { paths } from "src/routes/paths";

import { useAuthContext } from "src/hooks/auth/use-auth-context";

import { useTranslate } from "src/locales";
import { EmailConnectionStatus } from "src/services/email-sync/email-sync.types";
import { useGetEmailConnectionStateQuery } from "src/services/email-sync/email-sync.service";

import Iconify from "src/components/iconify";

import { TenantType } from "src/types/enums";

export default function EmailSyncAlert() {

  const { t } = useTranslate();

  const authContext = useAuthContext();

  const router = useRouter();

  const [loading, setLoading] = useState(false);

  const { currentData: connectionState } = useGetEmailConnectionStateQuery();

  const shouldShowAlert = useMemo(() => {
    if (![TenantType.Client, TenantType.Recruiter].includes(authContext.account.type)) return false;
    if (!connectionState) return false;

    if (connectionState.status === EmailConnectionStatus.EXPIRED) {
      return true;
    }

    return false;

  }, [connectionState, authContext]);


  // Reconnect requires choosing a provider (Microsoft/Google) + backfill window, which live on
  // the account email settings page — route there rather than initiating OAuth blindly.
  const handleInitiateConnect = () => {
    setLoading(true);
    router.push(paths.dashboard.account.email);
  };

  if (!shouldShowAlert) return null;

  return (
    <Box sx={{ width: '100%', p: .5 }}>
      <Alert
        severity='warning'
        sx={{ mb: 2, width: "100%" }}
        action={
          <LoadingButton
            loading={loading}
            variant="contained"
            size="small"
            sx={{ mt: 1 }}
            endIcon={<Iconify icon='material-symbols:lock-reset-rounded' />}
            onClick={handleInitiateConnect}
          >
            {t('email_sync.expired_alert.button')}
          </LoadingButton>
        }
      >
        <Stack direction='column' gap={0} alignItems='start' flexGrow={1}>
          <Typography variant='subtitle2'>
            {t('email_sync.expired_alert.title')}
          </Typography>
          <Typography variant='caption'>
            {t('email_sync.expired_alert.subtitle')}
          </Typography>
        </Stack>

      </Alert >
    </Box>
  )
}